import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Mapper, MapperPipe, StringHelper } from 'tiime-expert-utils';
import { TiimeAutocompleteModule, TiimeIconModule } from 'tiime-material';

import { AutocompleteBaseComponent } from '@bases/autocomplete/autocomplete.base';
import { ThreadTag } from '@models/thread-tag';
import { ArchivedPipe } from '@shared-pipes/archived/archived.pipe';
import { SortByKeyPipe } from '@shared-pipes/sort-by-key/sort-by-key.pipe';

@Component({
  standalone: true,
  selector: 'app-thread-tag-autocomplete',
  templateUrl: './thread-tag-autocomplete.component.html',
  styleUrls: ['./thread-tag-autocomplete.component.scss'],
  exportAs: 'ThreadTagAutocomplete',
  imports: [TiimeIconModule, MapperPipe, SortByKeyPipe, ArchivedPipe, TiimeAutocompleteModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThreadTagAutocompleteComponent extends AutocompleteBaseComponent<ThreadTag> {
  @Input() selectedTags: ThreadTag[] = [];

  readonly mapToExactMatch: Mapper<ThreadTag[], ThreadTag[]> = (tags: ThreadTag[], search: string): ThreadTag[] =>
    tags.filter(
      (tag: ThreadTag) =>
        StringHelper.normalizeToLowerCase(tag?.name ?? '') === StringHelper.normalizeToLowerCase(search ?? '')
    );

  readonly mapToShowCreateThreadTag: Mapper<string, boolean> = (
    currentThreadTagInputValue: ThreadTag | string,
    tags: ThreadTag[]
  ): boolean =>
    !(this.selectedTags ?? []).some(
      (selectedTag: ThreadTag) => selectedTag.name === this.extractName(currentThreadTagInputValue)
    ) &&
    !(tags ?? []).some(
      (tag: ThreadTag) =>
        StringHelper.normalizeToLowerCase(tag.name ?? '') ===
        StringHelper.normalizeToLowerCase(this.extractName(currentThreadTagInputValue) ?? '')
    ) &&
    !!currentThreadTagInputValue;

  private extractName(value: ThreadTag | string): string {
    return typeof value === 'string' ? value : value?.name;
  }
}
